import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card-header border-0 pt-5" }
const _hoisted_2 = { class: "card-title align-items-center" }
const _hoisted_3 = { class: "svg-icon svg-icon-2 me-2 text-primary" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "card-label fw-bold fs-3" }, "Direct Sponsored", -1)
const _hoisted_5 = { class: "card-body py-3" }
const _hoisted_6 = { class: "seq-period-filter mb-6" }
const _hoisted_7 = { class: "seq-period-filter__field seq-period-filter__field--date" }
const _hoisted_8 = /*#__PURE__*/_createVNode("label", { class: "seq-period-filter__label" }, "From Date", -1)
const _hoisted_9 = { class: "seq-period-filter__field seq-period-filter__field--date" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", { class: "seq-period-filter__label" }, "To Date", -1)
const _hoisted_11 = { class: "table-responsive" }
const _hoisted_12 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_13 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "text-muted fw-semibold fs-8 text-uppercase" }, [
    /*#__PURE__*/_createVNode("th", { class: "ps-4" }, "Ref. #"),
    /*#__PURE__*/_createVNode("th", null, "Fullname"),
    /*#__PURE__*/_createVNode("th", null, "Date"),
    /*#__PURE__*/_createVNode("th", { class: "pe-4" }, "Sponsor")
  ])
], -1)
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/_createVNode("td", {
  colspan: "4",
  class: "text-center text-muted py-10"
}, "No direct sponsored records found.", -1)
const _hoisted_16 = { class: "ps-4" }
const _hoisted_17 = { class: "text-muted fs-8" }
const _hoisted_18 = { class: "d-flex align-items-center" }
const _hoisted_19 = { class: "seq-row-icon seq-row-icon--blue me-3" }
const _hoisted_20 = { class: "svg-icon svg-icon-3 svg-icon-white" }
const _hoisted_21 = { class: "fw-semibold text-gray-800" }
const _hoisted_22 = { class: "text-muted fs-8" }
const _hoisted_23 = { class: "text-muted fs-8" }
const _hoisted_24 = { class: "pe-4" }
const _hoisted_25 = { class: "fw-semibold text-gray-800" }
const _hoisted_26 = { class: "text-muted fs-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_inline_svg = _resolveComponent("inline-svg")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 10,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _withDirectives(_createVNode("div", {
      class: [_ctx.widgetClasses, "card seq-card"]
    }, [
      _createVNode("div", _hoisted_1, [
        _createVNode("h3", _hoisted_2, [
          _createVNode("span", _hoisted_3, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotone/General/User.svg" })
          ]),
          _hoisted_4
        ])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _hoisted_8,
            _withDirectives(_createVNode("input", {
              type: "date",
              class: "seq-period-filter__input",
              name: "from_date",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.from_date = $event))
            }, null, 512), [
              [_vModelText, _ctx.from_date]
            ])
          ]),
          _createVNode("div", _hoisted_9, [
            _hoisted_10,
            _withDirectives(_createVNode("input", {
              type: "date",
              class: "seq-period-filter__input",
              name: "to_date",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.to_date = $event))
            }, null, 512), [
              [_vModelText, _ctx.to_date]
            ])
          ]),
          _createVNode("button", {
            type: "button",
            class: "btn btn-seq-view",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.directsponsoredhistory()))
          }, " View ")
        ]),
        _createVNode("div", _hoisted_11, [
          _createVNode("table", _hoisted_12, [
            _hoisted_13,
            _createVNode("tbody", null, [
              (_ctx.list.length === 0)
                ? (_openBlock(), _createBlock("tr", _hoisted_14, [
                    _hoisted_15
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
                return (_openBlock(), _createBlock("tr", { key: index }, [
                  _createVNode("td", _hoisted_16, [
                    _createVNode("span", _hoisted_17, _toDisplayString(item.id), 1)
                  ]),
                  _createVNode("td", null, [
                    _createVNode("div", _hoisted_18, [
                      _createVNode("span", _hoisted_19, [
                        _createVNode("span", _hoisted_20, [
                          _createVNode(_component_inline_svg, { src: "media/icons/duotone/General/User.svg" })
                        ])
                      ]),
                      _createVNode("div", null, [
                        _createVNode("div", _hoisted_21, _toDisplayString(item.userFullname), 1),
                        _createVNode("div", _hoisted_22, _toDisplayString(item.usid) + " · " + _toDisplayString(item.upref) + " / " + _toDisplayString(item.packagestatus), 1)
                      ])
                    ])
                  ]),
                  _createVNode("td", null, [
                    _createVNode("div", _hoisted_23, _toDisplayString(item.dteStp), 1)
                  ]),
                  _createVNode("td", _hoisted_24, [
                    _createVNode("div", _hoisted_25, _toDisplayString(item.sponsorFullname), 1),
                    _createVNode("div", _hoisted_26, _toDisplayString(item.spid), 1)
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ], 2), [
      [_vShow, !_ctx.loading]
    ])
  ], 64))
}